import React from "react";
import { FieldProps } from "./types";

type BivariantCallback<TArg, TResult> = { bivarianceHack(arg: TArg): TResult }["bivarianceHack"];

interface CustomProps extends FieldProps {
    renderer: BivariantCallback<unknown, React.ReactNode | string | null>;
}

const CustomField: React.FC<CustomProps> = ({ record, renderer }) => {
    return <React.Fragment>{renderer(record)}</React.Fragment>;
};

export default CustomField;
